import { useMutateDeleteExternalBankAccount } from '../../models/useMutateDeleteExternalBankAccount'

/**
 * Hook-only command presenter (ADR-2): the delete mutation only. The promise
 * REJECTS with RepoError so the FS confirmation handler can toast via
 * getMessageFromError (ADR-4/ADR-10) — no toast, confirmation, or UI here
 * (FS-owned, BHV-026).
 */
export const useDeleteExternalBankAccountPresenter = () => {
  const { mutateAsync, isLoading } = useMutateDeleteExternalBankAccount()

  return {
    commands: {
      deleteBankAccount: (id: number): Promise<void> => mutateAsync(id),
    },
    states: {
      isDeleting: isLoading,
    },
  }
}
